import { rankItems } from "@/mocks/home";

export default function RankingBoard() {
  return (
    <section id="ranking" className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[0.72fr_1.28fr] gap-8 lg:gap-14">
          {/* intro */}
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label text-accent-400">
              <i className="ri-bar-chart-2-line" aria-hidden="true"></i>
              实时热度榜
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-[32px] font-bold leading-snug">
              今日爆料
              <br />
              热度榜单
            </h2>
            <p className="mt-4 text-sm leading-7 text-background-200/80 max-w-sm">
              按站内阅读、讨论与转发综合计算，每小时刷新一次。榜单只反映热度高低，不代表爆料内容的真实性。
            </p>
            <div className="mt-6 flex items-center gap-3 text-xs text-background-300">
              <span className="flex items-center gap-1.5">
                <i className="ri-refresh-line" aria-hidden="true"></i>
                每 60 分钟更新
              </span>
              <span className="w-1 h-1 rounded-full bg-background-500"></span>
              <span>数据截至 09:20</span>
            </div>
          </div>

          {/* list */}
          <ol className="divide-y divide-background-100/10">
            {rankItems.map((item) => (
              <li key={item.rank}>
                <a
                  href="#today"
                  className="group flex items-center gap-4 md:gap-6 py-4 hover:bg-background-50/5 transition-colors rounded-md px-2 -mx-2"
                >
                  <span
                    className={`w-9 md:w-11 shrink-0 text-center font-heading font-bold text-2xl md:text-3xl tabular-nums ${
                      item.rank <= 3 ? "text-accent-400" : "text-background-400"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm md:text-[15px] font-medium leading-6 text-background-50 group-hover:text-accent-300 transition-colors">
                      {item.title}
                    </p>
                    <div className="mt-1.5 flex items-center gap-3 text-xs text-background-400">
                      <span>{item.heat}</span>
                      <span className="flex items-center gap-1 text-accent-400/90">
                        <i className="ri-arrow-up-line" aria-hidden="true"></i>
                        {item.trend}
                      </span>
                    </div>
                  </div>
                  <span
                    className={`hidden sm:inline-flex shrink-0 w-7 h-7 items-center justify-center rounded-sm text-xs font-label ${
                      item.tag === "爆"
                        ? "bg-primary-500 text-background-50"
                        : item.tag === "热"
                          ? "bg-secondary-500 text-background-50"
                          : "bg-background-50/10 text-background-200"
                    }`}
                  >
                    {item.tag}
                  </span>
                </a>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}